import React, { useCallback, useEffect, useMemo, useReducer } from 'react'
import { Box, Card, CardContent, Grid, IconButton, Stack, Typography } from '@mui/material';
import { CloudDoneOutlined, CloudOffOutlined } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { equipmentTypeModel } from '../AppGrid/EquipmentTypeTable';
import util from '../util/index';
import connectionService from '../services/Connection';
import strings from '../Globalization/index';

const EquipmentTypeGridList = equipmentTypeModel.createGridListBase();

const ModalityItem = ({ data, itemProps, ...rest }) => {

	let clientId = 0;
	if (util.localData.loginData) {
		let parseData = util.localData.loginData;
		clientId = parseData.tags.ClientId;
	}

	const totalDisconnected = data.TotalEquipment - data.TotalConnected;
	const connected = !!data.IsConnected;

	return (
		<Box sx={{ margin: "0px 10px", textDecoration: 'none', borderBottomStyle: 'none', height: 'max-content' }} component={Link} to={`/modalitydashboard?EquipmentTypeId=${data.EquipmentTypeId}`} >
			<Card variant="outlined" sx={{
				'&:hover': {
					boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.75)',
					transition: 'all 0.3s ease-in-out',
				},
				'& .MuiPaper-root': {
					height: 'max-content'
				}
			}}>
				<Box display="flex" alignItems="center" justifyContent="center" marginTop='1rem'>
					<Box component="img"
						src={`${connectionService.PTXImage}/${'EquipmentType/' + clientId}/${data.EquipmentTypeImage}?v=${new Date()}`}
						alt="washer"
						loading="eager"
						sx={{
							width: 'auto',
							maxWidth: '70%',
							height: theme => theme.spacing(20),
							objectFit: 'contain',
							margin: 'auto',
							marginTop: '1rem',
							marginBottom: '0.2rem',
						}}
					/>
				</Box>

				<CardContent sx={{
					marginTop: '1rem',
					height: 'max-content',
					backgroundColor: '#f7f7f7',
					padding: '0.5rem 0.5rem 0.5rem 0.5rem',
					borderBottomRightRadius: '5px',
					borderBottomLeftRadius: '5px',
				}}>
					<Stack direction="row" spacing={1} >
						<Box display="flex" flexDirection="column" flex={1} alignItems="flex-start">
							<Typography variant="body1" sx={{ color: '#418fde', fontWeight: 'bold', textDecoration: 'none', borderBottomStyle: 'none !important' }} >{data.Name}</Typography>
							<Typography variant="body1" sx={{ color: '#000000', fontWeight: 'bold', textDecoration: 'none', borderBottomStyle: 'none !important' }} title={strings.Tasks}>{data.Tasks} {strings.Tasks}</Typography>
						</Box>

						{itemProps.connected &&
							<Box display="flex" flexDirection="column" alignItems="center">
								<IconButton color={"success"} aria-label="cloud done"> <CloudDoneOutlined /></IconButton>
								<Typography variant="body1" sx={{ color: '#418fde', fontWeight: 'bold' }}>{data.TotalConnected}</Typography>
							</Box>
						}

						{itemProps.disconnected &&
							<Box display="flex" flexDirection="column" alignItems="center">
								<IconButton color={"text.secondary"} aria-label="cloud off"><CloudOffOutlined /></IconButton>
								<Typography variant="body1" sx={{ color: '#418fde', fontWeight: 'bold' }}>{totalDisconnected}</Typography>
							</Box>
						}
					</Stack>
				</CardContent>
			</Card>
		</Box>
	);
}

const ModalityInfo = ({ data, extraParams, dataProperty, comboTypes, ...rest }) => {
	const theme = useTheme();
	const isLg = useMediaQuery(theme.breakpoints.up('lg'));
	const [state, setState] = useReducer(
		(prev, next) => (typeof next === 'function' ? { ...prev, ...next(prev) } : { ...prev, ...next }),
		{
			loading: false,
			locationId: '',
			equipmentTypeId: '',
			data: data,
			extraParams: extraParams
		}
	);

	const apiParams = useMemo(() => ({
		action: "otherAction", otherAction: "ModalityList", locationId: 0, equipmentTypeId: 0,
		disconnected: true, connected: true, equipmentActive: true, equipmentInActive: false, ...extraParams
	}), [extraParams]);

	const loadData = useCallback(async ({ setIsLoading, setData, apiParams, setCombos }) => {

			const searchParams = new URLSearchParams();
			Object.keys(apiParams).forEach(key => searchParams.append(key, apiParams[key]));

			setIsLoading(true);

			fetch(connectionService.DashBoardEqupmentType, {
				method: 'POST',
				headers: {
					'X-Background-Request': 'true'
				},
				body: searchParams,
			}).then(res => res.json())
				.then(({ records, combos, recordCount, data }) => {
					if (typeof setCombos === 'function') {
						setCombos(combos);
					}
					setData({ rows: Array.isArray(records)? records : data || [], rowCount: recordCount || data?.length || 0 });
				}).catch(err => {

				}).finally(() => {
					setIsLoading(false);
				});
		 
	}, []);

	return (
		<EquipmentTypeGridList fetchData={loadData} apiParams={apiParams}
			component={ModalityItem} itemProps={extraParams} disablePagination placeholder={Box} noOfitemsPerRow={isLg ? 4 : 2} noRecordMsg={'No Equipment Found'} />
	)
}

export default ModalityInfo;
